import { Box, Flex, Text } from '@chakra-ui/react';
import SubmittingAuthor from '../components/SubmittingAuthor';
import CorrespondingAuthor from '../components/CorrespondingAuthor';
import ContactAuthor from '../components/ContactAuthor';
import { IAuthorStepConfig } from 'src/hooks/useSubmissionStepsConfig';
import { IUser } from '@publishing-engine/domain/fixtures';
import { useSubmissionContextData } from 'src/contexts/SubmissionContextProvider';

const SubmissionManagement = ({
  configs,
  user
}: {
  configs: IAuthorStepConfig;
  user: IUser;
}) => {
  const { submissionContext } = useSubmissionContextData();
  const reviewAuthorInformation =
    submissionContext?.config.cms.authorSubmissionForm.reviewAuthorInformation;
  return (
    <Flex
      flexDirection="column"
      gap={4}
      alignItems="flex-start"
      width="100%"
      data-cy="submission-management"
    >
      <Box>
        <Text
          textStyle="headingGroup"
          data-cy="submission-management-heading"
          id={
            reviewAuthorInformation?.submissionManagementInformation.mainLabel
          }
        >
          {reviewAuthorInformation?.submissionManagementInformation.mainLabel}
        </Text>
        <Text textStyle="textBody" data-cy="submission-management-description">
          {
            reviewAuthorInformation?.submissionManagementInformation
              .secondaryLabel
          }
        </Text>
      </Box>

      {/* ----- Submitting Author ----- */}
      {configs.SubmittingAuthor && (
        <SubmittingAuthor
          key="submitting-author"
          config={configs.SubmittingAuthor}
          submittingUser={user}
          data-cy="submitting-author"
        />
      )}

      {/* ----- Contact Author ----- */}
      {configs.ContactAuthor && (
        <ContactAuthor
          key="contact-author"
          config={configs.ContactAuthor}
          data-cy="contact-author"
        />
      )}

      {/* ----- Corresponding Author ----- */}
      {configs.CorrespondingAuthor && (
        <CorrespondingAuthor
          key="corresponding-author"
          config={configs.CorrespondingAuthor}
          data-cy="corresponding-author"
        />
      )}
    </Flex>
  );
};

export default SubmissionManagement;
